export default __webpack_public_path__ + "fb441267dc08dc3b970b499eaee2595d.png";